/**
 * @module salaryFrequency
 * @description A list of salaryFrequency
 */

export const salaryFrequency = [
	'daily',
	'weekly',
	'monthly',
	'annually',
	'onceoff',
] as const;
export type SalaryFrequency = (typeof salaryFrequency)[number];
